import { handleResponse } from '../Helpers/handle-response';

export const clientDataService = {
    getClients,
    deleteClient,
    editRow,
    addRow,
    getPossibleClientProps
};

function getClients() {
    const requestOptions = { method: 'GET' };
    return fetch(process.env.REACT_APP_APIURL + 'clients', requestOptions).then(handleResponse);
}

function deleteClient(id) {
    const requestOptions = { method: 'DELETE' };
    return fetch(process.env.REACT_APP_APIURL + 'clients/deleteClient?id=' + id, requestOptions).then(handleResponse);
}

function editRow(row) {
    const requestOptions = { method: 'PUT', headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
    }, body: JSON.stringify(row) };
    return fetch(process.env.REACT_APP_APIURL + 'clients/editClient', requestOptions).then(handleResponse);
}

function addRow(row) {
    const requestOptions = { method: 'POST', headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
    }, body: JSON.stringify(row) };
    return fetch(process.env.REACT_APP_APIURL + 'clients/addClient', requestOptions).then(handleResponse);
}

function getPossibleClientProps(){
    const requestOptions = { method: 'GET' };
    return fetch(process.env.REACT_APP_APIURL + 'clients/allproperties', requestOptions).then(handleResponse);
}